import { useGetUrl } from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import { Alert, Stack, Text, TextLink } from 'braid-design-system';

import type { ProfileAvatarStatusFailureError } from 'src/components/Profile/Avatar/types';
import { useAppConfig } from 'src/modules/appConfig/AppConfigProvider';

interface Props {
  profileAvatarStatusFailureError?: ProfileAvatarStatusFailureError;
}

import translations from './.vocab';

export const UploadError = ({ profileAvatarStatusFailureError }: Props) => {
  const { zone, language } = useAppConfig();
  const getUrl = useGetUrl(zone, language);
  const { t } = useTranslations(translations);

  const { __typename, title, message } = profileAvatarStatusFailureError ?? {};
  const errorTitle = title ?? t('Something went wrong');
  const errorMessage = message ?? t('Please try again or check back later.');

  return (
    <Alert tone="critical">
      <Stack space="large">
        <Text weight="strong">{errorTitle}</Text>
        <Text>{errorMessage}</Text>
        {__typename === 'ProfileAvatarStatusModerationFailedError' ? (
          <Text>
            <TextLink href={getUrl('community-guidelines')}>
              {t('View guidelines')}
            </TextLink>
          </Text>
        ) : null}
      </Stack>
    </Alert>
  );
};
